import * as axios from '~/utilities/axios'

export function trackGoogleConversion(ticketId, conversionType, sessionToken, conversionValue) {
  if (!ticketId || !sessionToken) return

  axios
    .secure(sessionToken)
    .post(`${process.env.PARSE_DIR}/functions/trackGoogleConversion`, {
      ticketId,
      conversionType,
      ...(conversionValue != null && { conversionValue }),
    })
    .then(res => {
      const result = res.data?.result
      if (result?.skipped) {
        console.info(`[Google Ads] conversion skipped: ${result.reason}`)
      }
    })
    .catch(err => {
      console.error('[Google Ads] trackGoogleConversion failed:', err?.message || err)
    })
}
